module.exports = __webpack_public_path__ + "static/media/taxi.5f63fe6e.jpg";